export default function handleContainerClick() {
  const bindLinks = document.querySelectorAll('[data-bind-link]');
  bindLinks.forEach((link) => {
    link.addEventListener('click', function () {
      if (true) {
        const firstAnchor = this.querySelector('a');
        if (firstAnchor) {
          firstAnchor.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: false,
            cancelable: true,
          }));
        }
      }
    });
  });
}

